'use client'

import type { LinkForesightProps } from '@pearlconvert/ui/components/link/link-foresight.types'

import NextLink from 'next/link'

import { useLinkForesight } from '@pearlconvert/ui/components/link/batons/use-link-foresight'

export function LinkForesight({
  href,
  target,
  children,
  className,
  scroll,
  hitSlop,
  ...props
}: LinkForesightProps) {
  const { elementRef } = useLinkForesight(href, hitSlop)

  return (
    <NextLink
      className={className}
      target={target}
      href={href}
      scroll={scroll}
      prefetch={false}
      ref={elementRef}
      {...props}
    >
      {children}
    </NextLink>
  )
}
